import PropTypes from 'prop-types';

import { MediaContainer, MotionWrapper, CardImg } from './styles';

// * This Takes the images provided by the CMS and wraps them in an animated wrapper

const AnimatedCards = ({ imgs }) => {
  return (
    imgs && (
      <MediaContainer>
        {imgs.map(img => {
          return (
            <MotionWrapper key={img.id}>
              <CardImg
                className="contain"
                objectFit="contain"
                src={img}
                alt={img.altText || ''}
                loading="eager"
              />
            </MotionWrapper>
          );
        })}
      </MediaContainer>
    )
  );
};

AnimatedCards.propTypes = {
  imgs: PropTypes.arrayOf(PropTypes.shape()).isRequired,
};

export default AnimatedCards;
